<template>
  <div class="podcast">
    <div class="container container-fluid text-center vh-100" v-if="isLoading">
      <HMSpinner class="mt-4" />
    </div>
    <div
      class="container container-fluid text-center vh-100"
      v-if="!isLoading && !podcast"
    >
      <HMEmpty
        :image="config['page-404']"
        :title="$t('PODCASTS.TEXT.PODCAST_404_TITLE')"
        :description="$t('PODCASTS.TEXT.PODCAST_404_TEXT')"
      />
    </div>
    <div
      class="container podcast-container my-3 mt-5"
      v-if="podcast && episode"
    >
      <div class="row">
        <div
          clasS="col-12 d-flex flex-row justify-content-start align-items-start"
        >
          <div class="mr-3 mr-md-5">
            <PodcastThumbnail
              class="podcast-photo"
              :podcast="podcast"
              :hideOverlay="true"
            />
            <PodcastLinkIcons :podcast="podcast" />
          </div>
          <div
            class="d-flex flex-column justify-content-start align-items-start w-100"
          >
            <span class="c-charcoal py-1 small">
              {{ $formatDate(episode.published_on, 'date-word') }} •
              {{ duration }}
            </span>
            <h1>{{ episode.title }}</h1>
            <div
              class="d-flex flex-row justify-content-start align-items-center"
              v-if="instructorsCount"
            >
              <div class="d-flex flex-wrap mr-2">
                <HMInstructorsStack
                  class="d-none d-md-flex"
                  :instructors="[episode.media.instructor]"
                  :clickable="true"
                  size="40px"
                />
                <HMInstructorsStack
                  class="d-flex d-md-none"
                  :instructors="[episode.media.instructor]"
                  :clickable="true"
                  size="30px"
                />
              </div>
              <span class="c-charcoal py-1 smaller" v-if="instructorsCount">
                {{
                  $tc('PODCASTS.LABELS.HOSTS_VARIANT', instructorsCount, {
                    cnt: instructorsCount,
                  })
                }}
              </span>
            </div>
            <HMVueEditorPreview
              class="episode-description mt-3"
              v-if="episode.notes"
              :html="episode.notes"
            />
            <HMFilePreview :file="audio" class="mt-4 w-100" />
          </div>
        </div>
      </div>
      <hr class="mt-5" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '../../../core/utils/errors';
import { getConfig } from '../../utils/configuration';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import PodcastThumbnail from '../../components/podcasts/PodcastThumbnail';
import PodcastLinkIcons from '../../components/podcasts/PodcastLinkIcons';
import HMVueEditorPreview from '../../components/common/HMVueEditorPreview';

export default Vue.extend({
  name: 'StudioPodcastEpisodeDetails',
  components: {
    PodcastThumbnail,
    PodcastLinkIcons,
    HMVueEditorPreview,
  },
  computed: {
    config() {
      return getConfig();
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
    instructorsCount() {
      return this.episode?.media?.instructor ? 1 : 0;
    },
    episode() {
      return this.podcast?.episodes.find(
        episode => episode.id == this.$route.params.episode_id
      );
    },
    audio() {
      return this.episode.media.media;
    },
    duration() {
      const d = this.audio.audio_length;
      if (d < 60) {
        return this.$tc('GENERAL.LABEL.SECOND_VARIANT', d, {
          count: d,
        });
      }
      const dM = Math.round(d / 60);
      return this.$tc('GENERAL.LABEL.MINUTE_VARIANT', dM, {
        count: dM,
      });
    },
  },
  data() {
    return {
      isLoading: true,
      podcast: null,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        this.podcast = await this.$store.dispatch(
          'podcasts/loadStudioPodcast',
          {
            studioURL: this.studioURL,
            podcastId: this.$route.params.podcast_id,
          }
        );
        if (!this.episode) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to load this episode',
            text: 'Episode not found',
            duration: -1,
          });
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load this podcast',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.podcast-photo {
  width: 160px;
  height: 160px;

  @include media-breakpoint-up(md) {
    width: 220px;
    height: 220px;
  }
}

.mic-icon {
  background-color: var(--brand-color, $coral);
  border-radius: 50%;
  color: white;
  font-size: 12px;
  width: 40px;
  min-width: 40px;
  height: 40px;
}

.podcast-links {
  min-height: 72px;
  @include media-breakpoint-up(md) {
    border-left: 2px solid white;
  }
}

.episodes-list {
  border: 1px solid $light-gray;
  border-radius: $border-radius;
}
</style>
